import moment from 'moment';
import { ParsedQuery } from 'query-string';
import { DEFAULT_DATE_FORMAT } from 'api/models';
import { Transformer as SearchTransformer } from 'hooks/use-search';
import { AvailabilityFilter } from '../types';

export type ParsedAvailabilityFilterQuery = {
  availabilityCriteria: string | null;
};

export const to_parsed_availability_filter_query = ({
  availabilityCriteria,
}: ParsedQuery): ParsedAvailabilityFilterQuery => {
  if (availabilityCriteria == null) {
    return { availabilityCriteria: null };
  }

  return {
    availabilityCriteria:
      typeof availabilityCriteria === 'string'
        ? availabilityCriteria
        : availabilityCriteria[0],
  };
};
export const from_availability_filter_query = ({
  availabilityCriteria,
}: Partial<ParsedAvailabilityFilterQuery>): AvailabilityFilter | undefined => {
  try {
    if (availabilityCriteria == null) {
      return undefined;
    }
    const [dateString, availableMinutes, roles] =
      availabilityCriteria.split('~');
    const [startDateString, endDateString] = dateString.split('.');
    const startDate = moment(startDateString, DEFAULT_DATE_FORMAT);
    const endDate = moment(endDateString, DEFAULT_DATE_FORMAT);

    if (startDate.isValid() && endDate.isValid()) {
      return {
        startDate,
        endDate,
        availableMinutes: Number(availableMinutes),
        roles:
          roles != null && roles !== ''
            ? roles.split('.').map((id) => parseInt(id, 10))
            : [],
      };
    }
  } catch (e) {
    return undefined;
  }

  return undefined;
};
export const to_availability_report_query = (
  value?: AvailabilityFilter,
): ParsedAvailabilityFilterQuery => ({
  availabilityCriteria:
    value == null
      ? null
      : `${value.startDate.format(DEFAULT_DATE_FORMAT)}.${value.endDate.format(
          DEFAULT_DATE_FORMAT,
        )}~${value.availableMinutes}${
          value.roles.length ? `~${value.roles.join('.')}` : ''
        }`,
});

export const availabilityFilterTransformer: SearchTransformer<
  AvailabilityFilter | undefined
> = {
  from: (parsed) =>
    from_availability_filter_query(to_parsed_availability_filter_query(parsed)),
  to: to_availability_report_query,
};
